import type { RevisionFileData } from './useRevisionFileDelivery';

export function findRevision(
  revisions: RevisionFileData[],
  revisionId?: number,
  revisionNum?: number
): RevisionFileData | undefined {
  if (revisionId !== undefined) {
    return revisions.find((rev) => rev.id === revisionId) ?? revisions.at(-1);
  }

  if (revisionNum !== undefined) {
    return revisions[revisionNum] ?? revisions.at(-1);
  }

  return revisions.at(-1);
}
